import React from "react";

import {Col, Row} from "react-bootstrap";

import SectionContainerComponent from "@Components/Sections/SectionContainer";


import headImage from "./@Images/headSectionImage.svg";
import headSectionImage from "./@Images/headSectionImage.svg";
import disclaimerCard1Image from "./@Images/disclaimerCard1Image.svg";
import disclaimerCard2Image from "./@Images/disclaimerCard2Image.svg";
import disclaimerCard3Image from "./@Images/disclaimerCard3Image.svg";


import {CardComponent, IconCardComponent} from "@Components/Elements";

import iconCheck from "@Icons/SVG/icon-check.svg";

import iconSecurity_s from "@Icons/SVG/icon-security-s-green.svg";
import iconVisibilityOff_s from "@Icons/SVG/icon-visibility_off-s-green.svg";
import iconAccessTime_s from "@Icons/SVG/icon-access_time-s-green.svg";
import iconWorkWheel_s from "@Icons/SVG/icon-work_wheel-s-green.svg";
import iconSearch_s from "@Icons/SVG/icon-search-s-green.svg";
import iconFileDrive_s from "@Icons/SVG/icon-drive_file-s-green.svg";
import iconAttachMoney_s from "@Icons/SVG/icon-attach_money-s-green.svg";
import iconPercent_s from "@Icons/SVG/icon-percent-s-green.svg";

import iconPlane_l from "@Icons/SVG/icon-plane-l-orange.svg";
import iconBanking_l from "@Icons/SVG/icon-banking-l-orange.svg";
import iconHotel_l from "@Icons/SVG/icon-hotel-l-orange.svg";
import iconOfflineBolt_l from "@Icons/SVG/icon-offline_bolt-l-orange.svg";
import iconCart_l from "@Icons/SVG/icon-shopping_cart-l-orange.svg";
import iconStar_l from "@Icons/SVG/icon-star-l-orange.svg";
import iconSync_l from "@Icons/SVG/icon-sync-l-orange.svg";

import {ReactSVG} from "react-svg";
import {ButtonComponent} from "@Components/Forms";
import {HeadSectionComponent} from "../../Parts/Sections";
import "./index.scss";
import {PageContainerComponent} from "@Components/Sections";
import {UseQyvoUser} from "@Store/@Hooks";


const RefundCategoriesData = [
    {
        categoryID: 1,
        categoryIcon: iconPlane_l,
        categoryName: 'Air & ground travel',
        categoryActiveStatus: true,
        categoryDescription: 'Flight delays, cancellations, baggage fees, seat upgrades, and ground transportation refunds',
    },
    {
        categoryID: 2,
        categoryIcon: iconHotel_l,
        categoryName: 'Lodging & Accommodation',
        categoryActiveStatus: false,
        categoryDescription: 'Hotel bookings, vacation rentals, and accommodation fees',
    },
    {
        categoryID: 3,
        categoryIcon: iconSync_l,
        categoryName: 'Digital Subscriptions & SaaS',
        categoryActiveStatus: false,
        categoryDescription: 'Unused subscriptions and software services',
    },
    {
        categoryID: 4,
        categoryIcon: iconCart_l,
        categoryName: 'Retail & E-commerce',
        categoryActiveStatus: false,
        categoryDescription: 'Online purchases and retail transactions',
    },
    {
        categoryID: 5,
        categoryIcon: iconBanking_l,
        categoryName: 'Banking & Financial Services',
        categoryActiveStatus: false,
        categoryDescription: 'Banking fees and financial service charges',
    },
    {
        categoryID: 6,
        categoryIcon: iconOfflineBolt_l,
        categoryName: 'Utilities & Telecommunications',
        categoryActiveStatus: false,
        categoryDescription: 'Utility bills and telecom services',
    },
    {
        categoryID: 7,
        categoryIcon: iconStar_l,
        categoryName: 'Events, Tickets & Memberships',
        categoryActiveStatus: false,
        categoryDescription: 'Event tickets and membership fees',
    },
];





export const HowItWorksPage:React.FC = () => {


    const QyvoUser = UseQyvoUser();


    const RefundCategoriesList = RefundCategoriesData.map((item) => {
       return (
           <IconCardComponent
               key={item.categoryName}
               cardIcon={{ iconSrc: item.categoryIcon, iconSize: 'lg', iconBackground: 'none' }}
               cardTitle={item.categoryName}
               cardDescription={item.categoryDescription}
               cardSubTitle={item.categoryActiveStatus ? 'Available now' : 'Coming Soon'}
               cardActiveStatus={item.categoryActiveStatus}
               xl={4}
           />
       ) ;
    });


    return (
        <PageContainerComponent pageType={'how-it-works-page'}>

            <HeadSectionComponent
                pageName={'how-it-works-page'}
                sectionHeaderText={'How it works'}
                sectionSubText={'Three simple steps to turn your inbox into a money-finding machine. Connect, relax, and get paid - automatically.'}
                sectionImage={headSectionImage}
            />

            <SectionContainerComponent
                id={'how-it-works-page__disclaimer-section'}
                sectionType={'main'}
            >

                <CardComponent
                    type={1}
                    xs={12} xl={10}
                >
                    <Col xs={12} xl={9} className={'hiw-disclaimer-card__content'}>
                        <Row className={'hiw-disclaimer-card__content__content'}>
                            <Col xs={12} className={'hiw-disclaimer-card__content__head'}>
                                <Row className={'hiw-disclaimer-card__content__head__content'}>
                                    <Col xs={2} xl={'auto'} className={'hiw-disclaimer-card__content__head__order-nr'}>
                                        <span>1</span>
                                    </Col>
                                    <Col xs={10} xl={'auto'} className={'hiw-disclaimer-card__content__head__texts'}>
                                        <span className={'hiw-disclaimer-card__content__head__texts__header'}>Connect your e-mail</span>
                                        <span className={'hiw-disclaimer-card__content__head__texts__info'}>OAuth with Google / Microsoft (read-only by default)</span>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={12} className={'hiw-disclaimer-card__content__legend'}>
                                <Row className={'hiw-disclaimer-card__content__legend__content'}>
                                    <Col xs={12} className={'hiw-disclaimer-card__content__legend__element'}>
                                        <ReactSVG src={iconSecurity_s} wrapper={'span'} className={'svg-icon-element'} />
                                        <span className={'hiw-disclaimer-card__content__legend__element__text'}>Secure OAuth connection - we never store your password</span>
                                    </Col>
                                    <Col xs={12} className={'hiw-disclaimer-card__content__legend__element'}>
                                        <ReactSVG src={iconVisibilityOff_s} wrapper={'span'} className={'svg-icon-element'} />
                                        <span className={'hiw-disclaimer-card__content__legend__element__text'}>Read-only access by default - we can't send or delete emails</span>
                                    </Col>
                                    <Col xs={12} className={'hiw-disclaimer-card__content__legend__element'}>
                                        <ReactSVG src={iconAccessTime_s} wrapper={'span'} className={'svg-icon-element'} />
                                        <span className={'hiw-disclaimer-card__content__legend__element__text'}>Takes 30 seconds to connect and authorize</span>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} xl={3} className={'hiw-disclaimer-card__image'}>
                        <Row className={'hiw-disclaimer-card__image__content'}>
                            <img src={disclaimerCard1Image} alt={''} />
                        </Row>
                    </Col>
                </CardComponent>

                <CardComponent
                    type={1}
                    xs={12} xl={10}
                >
                    <Col xs={12} xl={9} className={'hiw-disclaimer-card__content'}>
                        <Row className={'hiw-disclaimer-card__content__content'}>
                            <Col xs={12} className={'hiw-disclaimer-card__content__head'}>
                                <Row className={'hiw-disclaimer-card__content__head__content'}>
                                    <Col xs={2} xl={'auto'} className={'hiw-disclaimer-card__content__head__order-nr'}>
                                        <span>2</span>
                                    </Col>
                                    <Col xs={10} xl={'auto'} className={'hiw-disclaimer-card__content__head__texts'}>
                                        <span className={'hiw-disclaimer-card__content__head__texts__header'}>C.A.R.E. Finds Claims</span>
                                        <span className={'hiw-disclaimer-card__content__head__texts__info'}>Relax—no app to open</span>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={12} className={'hiw-disclaimer-card__content__legend'}>
                                <Row className={'hiw-disclaimer-card__content__legend__content'}>
                                    <Col xs={12} className={'hiw-disclaimer-card__content__legend__element'}>
                                        <ReactSVG src={iconWorkWheel_s} wrapper={'span'} className={'svg-icon-element'} />
                                        <span className={'hiw-disclaimer-card__content__legend__element__text'}>AI scans your entire email history automatically</span>
                                    </Col>
                                    <Col xs={12} className={'hiw-disclaimer-card__content__legend__element'}>
                                        <ReactSVG src={iconSearch_s} wrapper={'span'} className={'svg-icon-element'} />
                                        <span className={'hiw-disclaimer-card__content__legend__element__text'}>Identifies refundable fees, taxes, and charges</span>
                                    </Col>
                                    <Col xs={12} className={'hiw-disclaimer-card__content__legend__element'}>
                                        <ReactSVG src={iconFileDrive_s} wrapper={'span'} className={'svg-icon-element'} />
                                        <span className={'hiw-disclaimer-card__content__legend__element__text'}>Files claims with companies on your behalf</span>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} xl={3} className={'hiw-disclaimer-card__image'}>
                        <Row className={'hiw-disclaimer-card__image__content'}>
                            <img src={disclaimerCard2Image} alt={''}/>
                        </Row>
                    </Col>
                </CardComponent>

                <CardComponent
                    type={1}
                    xs={12} xl={10}
                >
                    <Col xs={12} xl={9} className={'hiw-disclaimer-card__content'}>
                        <Row className={'hiw-disclaimer-card__content__content'}>
                            <Col xs={12} className={'hiw-disclaimer-card__content__head'}>
                                <Row className={'hiw-disclaimer-card__content__head__content'}>
                                    <Col xs={2} xl={'auto'} className={'hiw-disclaimer-card__content__head__order-nr'}>
                                        <span>3</span>
                                    </Col>
                                    <Col xs={10} xl={'auto'} className={'hiw-disclaimer-card__content__head__texts'}>
                                        <span className={'hiw-disclaimer-card__content__head__texts__header'}>Get paid</span>
                                        <span className={'hiw-disclaimer-card__content__head__texts__info'}>Watch the money hit your card (25% success fee auto-billed)</span>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={12} className={'hiw-disclaimer-card__content__legend'}>
                                <Row className={'hiw-disclaimer-card__content__legend__content'}>
                                    <Col xs={12} className={'hiw-disclaimer-card__content__legend__element'}>
                                        <ReactSVG src={iconAttachMoney_s} wrapper={'span'} className={'svg-icon-element'} />
                                        <span className={'hiw-disclaimer-card__content__legend__element__text'}>Refunds go directly to your original payment method</span>
                                    </Col>
                                    <Col xs={12} className={'hiw-disclaimer-card__content__legend__element'}>
                                        <ReactSVG src={iconPercent_s} wrapper={'span'} className={'svg-icon-element'} />
                                        <span className={'hiw-disclaimer-card__content__legend__element__text'}>We only charge 25% when you get paid - no upfront fees</span>
                                    </Col>
                                    <Col xs={12} className={'hiw-disclaimer-card__content__legend__element'}>
                                        <ReactSVG src={iconAccessTime_s} wrapper={'span'} className={'svg-icon-element'} />
                                        <span className={'hiw-disclaimer-card__content__legend__element__text'}>Track all your refunds in real-time dashboard</span>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} xl={3} className={'hiw-disclaimer-card__image'}>
                        <Row className={'hiw-disclaimer-card__image__content'}>
                            <img src={disclaimerCard3Image} alt={''}/>
                        </Row>
                    </Col>
                </CardComponent>

            </SectionContainerComponent>

            <SectionContainerComponent
                id={'how-it-works-page__refund-categories-section'}
                sectionHeaderText={'Refund Categories Covered by Qyvo C.A.R.E.'}
                sectionDescriptionText={'We\'re starting with Air & Ground Travel and expanding to more categories'}
            >

                <Col xs={12} className={'how-it-works-page__refund-categories-section__cards-list'}>
                    <Row className={'how-it-works-page__refund-categories-section__cards-list__content'}>
                        {RefundCategoriesList}
                    </Row>
                </Col>

            </SectionContainerComponent>

            {!QyvoUser &&
            <SectionContainerComponent id={'how-it-works-page__cta-section'}>

                <Col xs={12} className={'how-it-works-page__cta-section__head'}>
                    <span>Ready to Start Getting Refunds?</span>
                </Col>

                <Col xs={12} className={'how-it-works-page__cta-section__text'}>
                    <span>Join thousands of users who are already getting money back automatically</span>
                </Col>

                <Col xs={12} className={'how-it-works-page__cta-section__button'}>
                    <ButtonComponent
                        text={'Start getting refunds'}
                        href={'/join-qyvo'}
                        type={'cta'}
                        size={'l'}
                    />
                </Col>

            </SectionContainerComponent>
            }

        </PageContainerComponent>
    );

};


            export default HowItWorksPage;
